module.exports = __webpack_public_path__ + "img/quiz.c8ff2276.svg";